import { render, staticRenderFns } from "./TeacherAbsentStudentView.vue?vue&type=template&id=240c63ef"
import script from "./TeacherAbsentStudentView.vue?vue&type=script&lang=js"
export * from "./TeacherAbsentStudentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports